<template>
    <form class="filterform" @submit.prevent="applyFilter()">
        <div class="row">
            <div class="col-sm-4 col-3">
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('reportFilter.trackingNo')}}</label>
                    <div class="col-sm-8">
                        <div class="input-group input-group-sm mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{$route.params.accountCode.toUpperCase()}}</span>
                            </div>
                            <input type="number" v-model="data.FirstNumber" class="form-control" :placeholder="translate('first')">
                            <input type="number" v-model="data.LastNumber" class="form-control" :placeholder="translate('last')">
                        </div>
                        <div class="form-check  mb-3">
                            <input class="form-check-input" v-model="data.OnlyRevisions" type="checkbox" name="onlyRevisions" id="onlyRevisions" value="true">
                            <label class="form-check-label" for="onlyRevisions">{{translate('reportFilter.onlyRevisions')}}</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('reportFilter.startDate')}}</label>
                    <div class="col-sm-8">
                        <div class="input-group input-group-sm">
                            <date-input v-model="data.FirstDate" class="form-control" :max="max" :placeholder="translate('first')" />
                        </div>
                        <div class="input-group input-group-sm mb-3">
                            <date-input v-model="data.LastDate" class="form-control" :max="max" :placeholder="translate('last')" />
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('reportFilter.targetDate')}}</label>
                    <div class="col-sm-8">
                        <div class="input-group input-group-sm">
                            <date-input v-model="data.FirstTargetDate" class="form-control" :placeholder="translate('first')" />
                        </div>
                        <div class="input-group input-group-sm mb-3">
                            <date-input v-model="data.LastTargetDate" class="form-control" :placeholder="translate('last')" />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('reportFilter.jobName')}}</label>
                    <div class="col-sm-8">
                        <input type="text"  @input="checkInput('Title',$event)" v-model="data.Title" class="form-control form-control-sm" >
                    </div>
                </div>
            </div>
            <div class="col-sm-8 col-9">
                <div class="row">
                    <div class="col-4">
                        <label>{{translate('jobFinalizer.state')}}</label>
                        <checked-list-box name="durum" v-model="data.Status" :items="$izonay.jobStatus" style="height:130px">
                            <template v-slot:item="{item}">{{item.text}}</template>
                        </checked-list-box>
                    </div>
                    <div class="col-4">
                        <label>{{translate('approvalAuthorityEditorUser.department')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.DepartmentIds" :list="departments"></select-multiple>
                    </div>
                    <div class="col-4">
                        <label>{{translate('remPreview.receiver')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.TargetSystemIds" :list="targetSystems"></select-multiple>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <label>{{translate('reportFilter.flow')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.CirculationProfileSchemaIds" :list="circulationProfileSchemas"></select-multiple>
                    </div>
                    <div class="col-4">
                        <label>{{translate('reportFilter.starter')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.OwnerIds" :list="getDraftUsers()" :get-text="x => x.FullName" :get-value="x => x.Id"></select-multiple>
                    </div>
                    <div class="col-4">
                        <label>{{translate('reportFilter.waiter')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.WaitingUserIds" :list="getApproverUsers()" :get-text="x => x.FullName" :get-value="x => x.Id"></select-multiple>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <label>{{translate('reportFilter.signerOrApprover')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.ApprovedUserIds" :list="getApproverUsers()" :get-text="x => x.FullName" :get-value="x => x.Id"></select-multiple>
                    </div>
                    <div v-if="hasModule('REM')" class="col-4">
                        <label>{{translate('reportFilter.senderWithRem')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.REMSenderUserIds" :list="users" :get-text="x => x.FullName" :get-value="x => x.Id"></select-multiple>
                    </div>
                    
                    <div class="col-4">
                        <label>{{translate('reportFilter.categories')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.CategoryIds" :list="categories">
                            <template slot-scope="{ item }">
                                <div>
                                    <small class="float-right badge">{{item.Type | documentType }}</small>
                                {{item.Name}}
                                </div>
                            </template>
                        </select-multiple>
                        <div class="form-check">
                            <input class="form-check-input" id="categoryAll" name="CategoryOperator" type="radio" v-model="data.CategoryOperator" value="All" />
                            <label class="form-check-label" for="categoryAll">{{translate('reportFilter.includesAllSelectedCategories')}}</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" id="categoryAny" name="CategoryOperator" type="radio" v-model="data.CategoryOperator" value="Any" />
                            <label class="form-check-label" for="categoryAny">{{translate('reportFilter.includesAtLeastOneCategory')}}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="col-auto text-right" style="padding-top:30px;">
                            <button type="button" class="btn btn-outline-secondary" @click="cancel" style="margin-right:8px;">{{translate('cancel')}}</button>
                            <button type="submit" class="btn btn-success" accesskey="t" v-html="translate('applyFilters')"></button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <code>{{data}}</code> -->
        </div>
    </form>
</template>
<script>
import checkedListBox from './CheckedListBox.vue'
import DateInput from './DateInput.vue'
import selectMultiple from './SelectMultiple.vue'

export default {
    components: {
        checkedListBox,
        selectMultiple,
        DateInput
    },
    data(){
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const maxDate = new Date(today)
        return {
            data: {},
            approverUsers: null,
            draftUsers: null,
            max: maxDate,
        }
    },
    props: {
        targetSystems: {
            type: Array,
            required: true,
        },
        circulationProfileSchemas: {
            type: Array,
            required: true,
        },
        departments: {
            type: Array,
            required: true
        },
        users: {
            type: Array,
            required: true,
        },
        categories: {
            type: Array,
            required: true
        },
        filter: {
            type: Object,
            required: true
        }
    },
    created(){
        this.data = JSON.parse(JSON.stringify(this.filter));
        console.log('FilterForm Created');
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        applyFilter(){
            if(this.data.LastDate != null){
                var lastdate = new Date(this.data.LastDate);
                lastdate.setHours(23)
                lastdate.setMinutes(59)
                lastdate.setSeconds(59)
                console.log(lastdate);
                this.data.LastDate = lastdate;
            }
            this.$emit('apply', this.data);
        },
        cancel(){
            this.$emit('cancel');
        },
        getApproverUsers(){
            if(this.approverUsers == null || this.approverUsers.length == 0)
            {
                this.approverUsers = this.users.filter(x => 
                    x.Authorities.indexOf("Approver") >= 0 || 
                    x.Authorities.indexOf("Signer") >= 0
                );
            }

            return this.approverUsers;
        },
        getDraftUsers(){
            if(this.draftUsers == null || this.draftUsers.length == 0)
            {
                if(this.users != null && this.users.length > 0)
                {
                    this.draftUsers = this.users.filter(x => 
                        x.Authorities.indexOf("Draft") >= 0 || 
                        x.Authorities.indexOf("Admin") >= 0
                    );
                }
            }

            return this.draftUsers;
        }
    },
}
</script>
<style scoped>
    .filterform .form-group {
        margin-bottom: 0;
    }
</style>